import router from "./routes/router";
import store from "./store/store";
import App from "./App.vue";
import { createApp } from "vue";
import "@/index.css";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";
import { VueQueryPlugin } from "@tanstack/vue-query";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import vuetify from "./plugins/vuetify";
const app = createApp(App);

app.component("DatePicker", Vue3PersianDatetimePicker);

app.use(router);
app.use(store);
app.use(VueQueryPlugin);
app.use(VueSweetalert2);
app.use(vuetify)
app.use(Toast, {
  position: POSITION.TOP_CENTER,
  timeout: 1500,
  rtl: true,
  hideProgressBar: false,
  toastClassName: "toast",
  
});

app.mount("#app");
